import { useMemo } from 'react';
import { ReactNode } from '@tanstack/react-router';
import { createSafeContext } from '@mews/framework';
import { TableState, useTableState } from '@optimus-web/core';
import { ReservationTableFilters, ReservationsTableState } from './components/reservations';

interface ReservationsTableStateContextProps {
    reservationsTableState: TableState<ReservationsTableState, ReservationTableFilters>;
    setReservationsTableState: (state: TableState<ReservationsTableState, ReservationTableFilters>) => void;
}

export const { ReservationsTableStateContextProvider: ContextProvider, useReservationsTableStateContext } =
    createSafeContext<'ReservationsTableStateContext', ReservationsTableStateContextProps>(
        'ReservationsTableStateContext'
    );

export const ReservationsTableStateContext = ({ children }: { children: ReactNode }) => {
    const [reservationsTableState, setReservationsTableState] = useTableState<
        ReservationsTableState,
        ReservationTableFilters
    >();

    const contextValue = useMemo(
        () => ({
            reservationsTableState,
            setReservationsTableState,
        }),
        [reservationsTableState, setReservationsTableState]
    );

    return <ContextProvider value={contextValue}>{children}</ContextProvider>;
};
